import { render } from "./menu_item.vue?vue&type=template&id=4d727dec&scoped=true"
import script from "./menu_item.vue?vue&type=script&lang=js"
export * from "./menu_item.vue?vue&type=script&lang=js"

import "./menu_item.vue?vue&type=style&index=0&id=4d727dec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d727dec"]])

export default __exports__